import { useEffect, useState } from 'react'
import type { ReportRPALog, WrapperResponse } from '../../../model/kartera-api-model'
import { useHistory } from '../../../router/history'
import APIInvoke from '../../../utils/APIInvoke'
import { AUTOMATIONS_PATH, automationPath, errorMessage, formatSlashDateTime } from '../common/automation-common'

const LOAD_ERROR = 'No se pudo cargar el listado de procesos.'

export interface AutomationRow {
    id: number
    aseguradora: string
    abreviacion: string
    fecha: string
    total: number
    status: string
}

const toRow = (log: ReportRPALog): AutomationRow => ({
    id: Number(log.id),
    aseguradora: log.aseguradora?.aseguradora || log.aseguradora?.abreviacion || 'Aseguradora',
    abreviacion: log.aseguradora?.abreviacion || '',
    fecha: formatSlashDateTime(log.fechaTermino) || formatSlashDateTime(log.fechaPrograma) || '—',
    total: Number(log.totalRegistros) || 0,
    status: log.status || '',
})

export const useAutomationListModel = () => {
    const history = useHistory()
    const [reloadToken, setReloadToken] = useState(0)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [items, setItems] = useState<ReportRPALog[]>([])

    useEffect(() => {
        let active = true
        const load = async () => {
            try {
                setLoading(true)
                setError(null)
                const payload: WrapperResponse<ReportRPALog[]> | null = await (await APIInvoke.invokeGET('/rpa/logs')).json()
                if (!active) return
                if (!payload?.ok) throw new Error(payload?.message || LOAD_ERROR)
                setItems(payload.body || [])
            } catch (loadError) {
                if (active) setError(errorMessage(loadError, LOAD_ERROR))
            } finally {
                if (active) setLoading(false)
            }
        }
        load()
        return () => { active = false }
    }, [reloadToken])

    const rows = items.filter((item) => item.id != null).map(toRow)

    return {
        loading,
        error,
        rows,
        totalPolicies: rows.reduce((acc, row) => acc + row.total, 0),
        reload: () => setReloadToken((token) => token + 1),
        openLog: (id: number) => history.push({ pathname: automationPath(id), state: { backUrl: AUTOMATIONS_PATH } }),
    }
}
